export default __webpack_public_path__ + "static/media/AdminActive.f426a831.svg";